const translation = {
  "site.name": "咻咻漫画",
  "site.slogan": "全集漫画免费 · 下拉式畅读",
  "nav.home": "首页",
  "nav.category": "分类浏览",
  "nav.about": "关于我们",
  "nav.korean": "韩漫全集",
  "nav.chinese": "国漫全集",
  "nav.japanese": "日漫完结",
  "nav.completed": "完结佳作",
  "hero.title": "咻咻漫画",
  "hero.subtitle": "全集漫画免费阅读平台",
  "hero.description": "汇集全集韩漫、全集国漫及日漫完结佳作，全部免费下拉式畅读，告别追更等待，一键沉浸漫画世界",
  "hero.explore": "立即探索",
  "hero.trending": "热门推荐",
  "section.hot": "🔥 热门推荐",
  "section.hot.desc": "大家都在看的全集漫画",
  "section.category": "分类浏览",
  "section.category.desc": "按类型探索你喜爱的漫画",
  "section.completed": "✨ 完结佳作",
  "section.completed.desc": "一口气看完，不再等待更新",
  "section.latest": "🆕 最近更新",
  "section.latest.desc": "最新上架的完结漫画",
  "manga.status.completed": "已完结",
  "manga.status.ongoing": "连载中",
  "manga.chapters": "话",
  "manga.views": "次阅读",
  "manga.read_now": "开始阅读",
  "manga.add_favorite": "加入收藏",
  "manga.related": "相关推荐",
  "manga.chapter_list": "章节列表",
  "manga.info": "漫画信息",
  "manga.author": "作者",
  "manga.category": "分类",
  "manga.total_chapters": "总章节",
  "manga.update_time": "更新时间",
  "manga.description": "作品简介",
  "category.all": "全部",
  "category.korean": "韩漫全集",
  "category.chinese": "国漫全集",
  "category.japanese": "日漫完结",
  "category.completed": "完结佳作",
  "category.filter_by": "筛选方式",
  "category.sort_popular": "最受欢迎",
  "category.sort_latest": "最近更新",
  "category.sort_chapters": "章节最多",
  "about.brand": "品牌介绍",
  "about.brand.desc": "咻咻漫画成立于2023年，致力于为广大漫画爱好者提供最全面的全集漫画阅读体验。我们坚信，好的漫画应该被完整地阅读，而不是让读者在追更中煎熬等待。",
  "about.mission": "我们的使命",
  "about.mission.desc": "打造中文世界最完整的全集漫画平台，让每一位读者都能享受到流畅的下拉式阅读体验，不再为追更、断更而烦恼。",
  "about.feature1.title": "全集收录",
  "about.feature1.desc": "专注收录已完结的韩漫、国漫、日漫作品，确保每一部漫画都能从头到尾完整阅读。",
  "about.feature2.title": "免费畅读",
  "about.feature2.desc": "所有漫画资源完全免费，无需付费订阅，真正实现零门槛阅读体验。",
  "about.feature3.title": "下拉式阅读",
  "about.feature3.desc": "采用下拉式阅读模式，流畅丝滑的滚动体验，让阅读漫画成为一种纯粹的享受。",
  "about.feature4.title": "持续更新",
  "about.feature4.desc": "持续收录最新完结的优质漫画作品，不断丰富漫画资源库，满足各类读者的需求。",
  "about.reputation": "用户口碑",
  "about.reputation.desc": "来自各地漫画爱好者的真实评价",
  "about.contact": "联系我们",
  "about.contact.desc": "如果您有任何建议、合作意向或问题反馈，欢迎通过以下方式联系我们",
  "about.contact.email": "电子邮箱",
  "about.contact.wechat": "微信公众号",
  "about.contact.qq": "QQ群",
  "about.contact.address": "公司地址",
  "footer.copyright": "© 2026 咻咻漫画 版权所有",
  "footer.links": "快速链接",
  "footer.categories": "漫画分类",
  "footer.about": "关于",
  "breadcrumb.home": "首页",
  "pagination.prev": "上一页",
  "pagination.next": "下一页",
  "search.placeholder": "搜索漫画...",
};

export default translation;